import { render, staticRenderFns } from "./MenuGroupProduct.vue?vue&type=template&id=2bd07d6c&lang=html"
import script from "./MenuGroupProduct.vue?vue&type=script&lang=js"
export * from "./MenuGroupProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports